import { render, staticRenderFns } from "./CreateUpdateVehicle.vue?vue&type=template&id=74c31b0b&scoped=true&"
import script from "./CreateUpdateVehicle.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateVehicle.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateVehicle.vue?vue&type=style&index=0&id=74c31b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c31b0b",
  null
  
)

export default component.exports